export default "__VITE_ASSET__f2efbfa8__"